import { Component } from 'react';
import Raven from 'raven-js';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  componentDidCatch(error) {
    Raven.captureException(error, {
      extra: {
        beaconsConfigId: this.props.beaconsConfigId
      },
      tags: {
        'onboarding-beacons': 'true'
      }
    });
  }
  render() {
    const {
      children,
      fallback: FallbackComponent
    } = this.props;
    if (this.state.hasError) {
      return FallbackComponent;
    }
    return children;
  }
}
export default ErrorBoundary;